import styled, { keyframes } from 'styled-components';

const strokeDash = keyframes`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`;

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;

const Host = styled.span`
  display: inline-block;
  width: 16px;
  height: 16px;
  animation: 1.4s linear 0s infinite normal none running ${rotate};
`;

const Svg = styled.svg`
  circle {
    stroke: currentColor;
    stroke-dasharray: 80px, 200px;
    stroke-dashoffset: 0;
    animation: 1.4s ease-in-out 0s infinite normal none running ${strokeDash};
  }
`;

export function Loading() {
  return (
    <Host>
      <Svg viewBox="22 22 44 44">
        <circle cx="44" cy="44" r="20.2" fill="none" strokeWidth="3.6" />
      </Svg>
    </Host>
  );
}
